import { render, staticRenderFns } from "./RejectRequestModal.vue?vue&type=template&id=4749472e&scoped=true"
import script from "./RejectRequestModal.vue?vue&type=script&lang=ts"
export * from "./RejectRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./RejectRequestModal.vue?vue&type=style&index=0&id=4749472e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749472e",
  null
  
)

export default component.exports